import React, { useEffect, useState, useRef } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Column } from "primereact/column";
import Spinner from "../../components/spinner";
import { axiosApi } from "../../../services/axios_api";
import PaginatorComponent from "../../components/paginator";
import useDebounce from "../../components/hooks/useDebounce";
import { toast } from "react-toastify";
import editIcon from "../../../../assets/assests/edit.png";
import RoleEditAddForm from "./role-edit-add-form";
import Dots from "../../../../assets/assests/detail.png";
import Details from "./details-role";
export default function RoleManagement({
  showDialog,
  setShowDialog,
  isEdit,
  setIsEdit,
  selectedData,
  globalFilter,
}) {
  const [res, setRes] = useState([]);
  const [rowselect, setRowselect] = useState(null);
  const [editable, setEditable] = useState();
  const [loading, setLoading] = useState(false);
  const [filteredList, setFilteredList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);

  const [showdetail, setShowdetail] = useState(false);
  const debouncedSearch = useDebounce(globalFilter, 500);

  const getRolesData = async (pageNumber = 1, pageSize = rows) => {
    setLoading(true);
    try {
      const response = await axiosApi.get(`Portal/roles/get-all-paginated`, {
        params: {
          pageNumber,
          pageSize,
          searchTerm: debouncedSearch || "",
        },
      });
      setFilteredList(response.data.body);
      setTotalRecords(response.data.totalRecords);
    } catch (error) {
      toast.error("Failed to fetch data.");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (event) => {
    const { first, rows } = event;
    setFirst(first);
    setRows(rows);
    const pageNumber = first / rows + 1;
    getRolesData(pageNumber, rows);
  };

  useEffect(() => {
    getRolesData();
  }, [debouncedSearch,res]);

  const onHide = () => {
    setShowDialog(false);
  };

  const editAction = (rowData) => {
    setEditable(true);
    setIsEdit(true);
    setRowselect(rowData);
    setShowDialog(true);
  };

  const actionTemplate = (rowData) => {
    return (
      <div className="action-buttons flex">
        <Button
          className=" p-button-edit p-0 mr-3"
          onClick={() => {
            editAction(rowData);
          }}
          aria-label="Edit"
        >
          <img src={editIcon} alt="Edit" />
        </Button>
        {/* <Button className="p-button-edit p-0 mr-3" onClick={() => showDetails(rowData)}>
          <img src={Dots} alt="Details" />
        </Button> */}
      </div>
    );
  };
  const showDetails = (rowData) => {
    setRowselect(rowData); 
    setShowdetail(true);
  }
  const columnsData = [
    {
      field: "id",
      header: "Role ID",
      body: (rowData) => rowData.id || "--",
    },
    {
      field: "name",
      header: "Role",
      body: (rowData) => rowData.name || "--",
    },
    {
      field: "description",
      header: "Description",
      body: (rowData) => rowData.description || "--",
    },
    {
      field: "Module",
      header: "Assign Module",
      body: (rowData) =>
        rowData.permissions && rowData.permissions.length > 0
          ? rowData.permissions.map((p) => p.moduleName).join(", ")
          : "--",
    },
    {
      header: "Action",
      body: actionTemplate,
    },
  ];

  return (
    <>
      <Dialog
        header={
          <div className="popup-header">
            <div className="popup-header-text">
              {isEdit ? "Edit Role" : "Add New Role"}
            </div>
          </div>
        }
        visible={showDialog}
        onHide={onHide}
        className="dialog-size"
      >
        <RoleEditAddForm
          rowData={isEdit ? rowselect : null}
          setShowDialog={setShowDialog}
          getRolesData={getRolesData}
          showDialog={showDialog}
          editable={editable}
          onHide={onHide}
          formData={isEdit ? selectedData : null}
          setRes={setRes}
        />
      </Dialog>
      <Dialog
        visible={showdetail}
        onHide={() => setShowdetail(false)}
        header=" Details"
       className="dialog-size"
      >
        <Details
                  rowData={ rowselect } />
      </Dialog>

      {loading && (
        <div className="spinner-overlay">
          <Spinner />
        </div>
      )}

      <div className="card card-container">
        <DataTable
          emptyMessage="No record found."
          value={filteredList}
          className="custom-data-table"
          scrollable
          globalFilter={globalFilter}
        >
          {columnsData.map((data, index) => (
            <Column
              key={index}
              field={data.field}
              header={data.header}
              body={data.body}
              frozen={data.frozen}
            />
          ))}
        </DataTable>
        {totalRecords > 0 && (
          <PaginatorComponent
            first={first}
            rows={rows}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </>
  );
}
